import { Reveal } from "./Motion";
import { CTAButton } from "./CTAButton";

export const CTASection = () => (
  <section className="border-t border-border bg-accent text-accent-foreground">
    <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-10 lg:py-28">
      <div className="grid gap-10 lg:grid-cols-2 lg:items-end">
        <Reveal>
          <span className="overline text-accent-foreground/70">Ready when you are</span>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
            Let's talk about your property — and your returns.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:pb-2">
          <p className="text-accent-foreground/80">
            Book a no-obligation consultation. We'll review your goals, assess your property, and show you exactly how full-service management works.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <CTAButton to="/contact" variant="solid" testid="cta-book-consultation" className="bg-primary-foreground !text-primary hover:!bg-primary hover:!text-primary-foreground">
              Book a Consultation
            </CTAButton>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
